/**
 * checkCallbackValid
 * @param response
 */
window.checkCallbackValid = function (response) {
    if (response.status === 'VALID') {
        $('#pseudoCardPan').val(response.pseudocardpan);
        $('#truncatedCardPan').val(response.truncatedcardpan);
        $('#step2Form').submit();
    } else {
        // Fehlernachricht wird automatisch von PayOne gesetzt
        $('.paymentCC').find('.form-field').removeClass('error');
        $('.error-' + response.errorcode).addClass('error');
    }
};

/**
 * check
 * @param errorTxt
 * @param iframes
 * @returns {boolean}
 */
window.check = function (errorTxt, iframes) {
    var selected = $('input[name="pay[paymentType]"]:checked').val();
    if (selected != 3) {
        return true;
    } else if (typeof iframes !== 'undefined') {
        $('#errorOutputCreditCard').hide();
        // Wenn PayOne-Zahlungsart nicht mit Schnittstellendaten aktiviert ist => ist iframes 'undefined'
        if (iframes.isComplete()) {
            // Perform "CreditCardCheck" to create and get a PseudoCardPan; then call your function "checkCallbackValid"
            iframes.creditCardCheck('checkCallbackValid');
        } else {
            $('#errorOutput').show();
            $('#errorOutput').html(errorTxt);
        }

        return false;
    }
};
